import {
    Component,
    ContentChild,
    DoCheck,
    HostBinding,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core'
import { NgModel } from '@angular/forms'

@Component({
    selector: 'col-vertical-input-container',
    templateUrl: './vertical-input-container.component.html',
    styles: [
        ':host { display: block; }',
        '.microcopia { margin-top: 2px; color: #777777; font-size: 85%; font-style: italic; }'
    ]
})
export class VerticalInputContainerComponent implements OnChanges, DoCheck {
    @Input() label: string
    @Input() errorMessages?: { [key: string]: string } = {}
    @Input() microcopia?: string

    @Input()
    @HostBinding('class.form-group')
    formGroupClass = true
    @HostBinding('class.has-error') hasErrorClass = false

    @ContentChild(NgModel) model: NgModel

    errorMessagesForView: { error: string; message: string }[] = []

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        this.handleInputsChanges(changes)
    }

    ngDoCheck() {
        this.verificarExistenciaDoViewChild()
        this.hasErrorClass = this.hasErrors()
    }

    hasError(key: string) {
        return this.model.hasError(key)
    }

    protected hasSuccess() {
        return this.model.valid && this.model.touched
    }

    protected hasErrors() {
        return (
            this.model.invalid &&
            (this.model.touched || this.model.formDirective.submitted)
        )
    }

    protected handleInputsChanges(changes: SimpleChanges) {
        if ('errorMessages' in changes) {
            this.errorMessagesForView = this.getErrorMessagesForView()
        }
    }

    protected verificarExistenciaDoViewChild() {
        if (!this.model) {
            throw new Error('Esse componente precisa ser usado com uma diretiva ngModel')
        }
    }

    protected getErrorMessagesForView() {
        const errorMessages = this.errorMessages || {}

        return Object.keys(errorMessages).map(key => {
            return { error: key, message: errorMessages[key] }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/common/vertical-input-container/vertical-input-container.component.ts